angular.module('messenger')
  .filter('unreadChats', function () {

    return function (chats) {
      return chats.filter(function (chat) {
        return chat.new;
      });
    };
  });
